export default __webpack_public_path__ + "static/media/enable-cam-chrome-mac.8c282767.png";